import React from 'react';
import { Chip, Typography } from '@mui/material';
import { TYPES_COMMANDES } from 'Components/ControleOrders/constants';
import { format } from 'date-fns';

const getColorFromRowValue = (row) => {
  if (row.noColor) return {};
  if (row.orange) return { color: '#FFA500' };
  if (row.red) return { color: 'red' };
  if (row.green) return { color: 'green' };
  return {};
};

export const TitleStyle = {
  fontSize: '12px',
  fontWeight: 500,
  borderBottom: 'none',
  textTransform: 'uppercase',
  background: '#e4e7ea',
  font: 'normal normal 600 10px Montserrat',
  letterSpacing: 0,
  color: '#707070',
  padding: '12px 3px',
  // marginLeft: '40px',
};
export const defaultColumnStyle = {
  font: 'normal normal 600 12px Montserrat',
  letterSpacing: 0,
  color: '#38485C',
  display: 'block',
  // marginLeft: '40px',
};

export const columns = [
  {
    id: 'depo',
    label: 'DÉPÔT',
    style: TitleStyle,
    render: ({ row, value }) => (
      <Typography style={{ ...defaultColumnStyle, color: row.id === 'total' && '#007BC6' }} display="inline">
        {value}
      </Typography>
    ),
  },
  {
    id: 'stock',
    label: 'STOCK DISPONIBLE',
    style: TitleStyle,
    render: ({ row, value }) => (
      <Typography style={{ ...defaultColumnStyle, color: row.id === 'total' && '#007BC6' }} sx={row.id === 'total' && { color: '#007BC6' }} display="inline">
        {value || 0}
      </Typography>
    ),
  },
];

export const columnsSAV2 = [
  {
    id: 'type',
    label: 'Type de document',
    style: TitleStyle,
    render: ({ value }) => value && (
    <Chip
      label={(
        <div style={{ font: 'normal normal 600 14px/18px Montserrat' }}>
          {TYPES_COMMANDES.find((t) => t.id === value)?.label}
        </div>
            )}
      style={TYPES_COMMANDES.find((t) => t.id === value)?.style}
    />
    ),
    order: 'type',
  },
  {
    id: 'reference',
    label: 'N° DE LA PIÈCE',
    style: TitleStyle,
    render: ({ value, row }) => (
      <Typography
        style={{
          ...defaultColumnStyle,
          ...getColorFromRowValue(row),
        }}
      >
        {value}
      </Typography>
    ),
    order: 'reference',
  },
  {
    id: 'date',
    label: 'Date et heure',
    style: TitleStyle,
    render: ({ value, row }) => (
      <Typography
        style={{ ...defaultColumnStyle, mr: '9px', ...getColorFromRowValue(row) }}
        display="inline"
      >
        {format(new Date(value), 'dd/MM/yyyy hh:mm:ss')}
      </Typography>
    ),
    order: 'date',
  },
  {
    id: 'client',
    label: 'CLIENT',
    style: TitleStyle,
    render: ({ value, row }) => (
      <Typography style={{ ...defaultColumnStyle, ...getColorFromRowValue(row) }}>
        {value}
      </Typography>
    ),
    order: 'client.name',
  },
  {
    id: 'pieceBl',
    label: 'N° bon de livraison',
    style: TitleStyle,
    render: ({ value, row }) => (
      <Typography style={{ ...defaultColumnStyle, ...getColorFromRowValue(row) }}>
        {value}
      </Typography>
    ),
  },
  {
    id: 'pieceBc',
    label: 'N° bon de commande',
    style: TitleStyle,
    render: ({ value, row }) => (
      <Typography style={{ ...defaultColumnStyle, ...getColorFromRowValue(row) }}>
        {value}
      </Typography>
    ),
  },
  {
    id: 'targetProduct',
    label: 'Quantité produit',
    style: TitleStyle,
    render: ({ value }) => (
      <Typography style={defaultColumnStyle}>
        {value.quantity}
      </Typography>
    ),
  },
  {
    id: 'targetProduct',
    label: 'Prix unitaire produit',
    style: TitleStyle,
    render: ({ value }) => (
      <Typography style={defaultColumnStyle}>
        {value.prixUnitaire}
      </Typography>
    ),
  },
  {
    id: 'targetProduct',
    label: 'Remise produit',
    style: TitleStyle,
    render: ({ value }) => (
      <Typography style={defaultColumnStyle}>
        {value.remise}
      </Typography>
    ),
  },
  {
    id: 'targetProduct',
    label: 'Montant TTC produit',
    style: TitleStyle,
    render: ({ value }) => (
      <Typography style={defaultColumnStyle}>
        {value.montantTtc}
      </Typography>
    ),
  },
  /* {
    id: 'targetProduct',
    label: 'Montant HT produit',
    style: TitleStyle,
    render: ({ value }) => (
      <Typography style={defaultColumnStyle}>
        {value.product.des}
      </Typography>
    ),
  }, */
  {
    id: 'targetProduct',
    label: 'Nom représentant',
    style: TitleStyle,
    render: ({ value }) => (
      <Typography style={defaultColumnStyle}>
        {value.commercial?.firstName}
        {' '}
        {value.commercial?.lastName}
      </Typography>
    ),
  },
  {
    id: 'repoId',
    label: 'Dépôt',
    style: TitleStyle,
    render: ({ value }) => (
      <Typography style={defaultColumnStyle}>
        {value === 1 && 'Bouskoura'}
        {value === 2 && 'Derb Omar'}
      </Typography>
    ),
    order: 'repoId',
  },
];
